import {AnalyzeListElementType, AnalyzeListMapType, AnalyzeSearchParamType} from "../interface";
import {useExportInventoryAnalysisExcel} from "../hooks/useExportInventoryAnalysisExcel";
import EmptyTableRow from "../../../../common/EmptyTableRow";
import useGoToNavigation from "../../../../../util/useGotoNavigation";
import DisplayNumber from "../../../../../components/common/number/DisplayNumber";

interface PropsType {
    analyze: AnalyzeListMapType
    searchParam: AnalyzeSearchParamType
}

interface TdMapType {
    "규격": string,
    "단위": string,
    "현재 재고량": string,
    "기간 중 평균 재고량": string,
    "총 입고량": string,
    "총 출고량": string,
    "일 평균 입고량": string,
    "일 평균 출고량": string,
    "주문필요여부": string,
}

const useDynamicTable = (analyze: AnalyzeListMapType) => {
    const dynamicTh = () => {
        return <tr>
            <th>벤더</th>
            <th>카테고리</th>
            <th>품목</th>

            {analyze.formulaList.map(el => {
                const name = el.formulaName?.replaceAll("*", "")

                return el.isHidden === "N" && <th>{name}</th>
            })}
        </tr>
    }

    const dynamicTd = (el: AnalyzeListElementType) => {
        const tdMap: TdMapType = {
            "규격": "newTxtStndItem",
            "단위": "inventoryUnit",
            "현재 재고량": "inventoryAmount",
            "기간 중 평균 재고량": "avgInventoryAmountInPeriod",
            "총 입고량": "totalIncomingAmount",
            "총 출고량": "totalOutgoingAmount",
            "일 평균 입고량": "avgDailyIncoming",
            "일 평균 출고량": "avgDailyOutgoing",
            "주문필요여부": "needToOrder"
        }

        return <tr>
            <td className="text-center">{el.vendor}</td>
            <td className="text-center">{el.category}</td>
            <td className="text-center">{el.newTxtNmItem}</td>

            {analyze.formulaList.map(el2 => {
                const key = el2.formulaName?.replaceAll("*", "")
                const value = tdMap[key as keyof TdMapType]

                const numericKey = [
                    "inventoryAmount",
                    "avgInventoryAmountInPeriod",
                    "totalIncomingAmount",
                    "totalOutgoingAmount",
                    "avgDailyIncoming",
                    "avgDailyOutgoing",
                ]
                const flag = numericKey.includes(value)

                return el2.isHidden === "N" &&
                    <td className="text-center">
                        {flag ? <DisplayNumber
                            value={el[value as keyof AnalyzeListElementType]}/> : el[value as keyof AnalyzeListElementType]}
                    </td>
            })}
        </tr>
    }

    const dynamicEmptyRow = () => {
        const count = analyze.formulaList.filter(el => el.isHidden === "N").length

        return <EmptyTableRow colSpan={3 + count}/>
    }

    return {dynamicTh, dynamicTd, dynamicEmptyRow}
}

export default function List({analyze, searchParam}: PropsType) {
    const {goToNavigation} = useGoToNavigation();
    const {dynamicTh, dynamicTd, dynamicEmptyRow} = useDynamicTable(analyze)

    const {mutate: mutateExportInventoryAnalysisExcel} = useExportInventoryAnalysisExcel()

    const btnExportExcel = () => {
        mutateExportInventoryAnalysisExcel({...searchParam, pageNo: 1, limit: 1000000})
    }

    const btnGoToFormula = () => {
        goToNavigation("inventory/analyze/formula", {}, false)
    }

    return <div className="content_wrap">
        <div className="table_top">
            <h6 className="table_stats">재고 목록(<span>{analyze.totalCount ?? 0}</span>건)</h6>
            <div className="table_toolbar">
                <button className="btn btn-dark w-150px px-0" onClick={btnExportExcel}><img
                    src={process.env.PUBLIC_URL + "/assets/images/icon_export.png"} alt=""/>엑셀 내보내기
                </button>
                <button className="btn btn-outline-primary ms-40px" onClick={btnGoToFormula}>
                    <img src={process.env.PUBLIC_URL + "/assets/images/icon_gear_blue.png"} alt=""/>수식설정
                </button>
            </div>
        </div>

        <div style={{overflowY: 'auto', height: '500px'}}>
            <table className="table table-bordered my_table">
                <thead style={{position: 'sticky', top: 0}}>
                {dynamicTh()}
                </thead>
                <tbody>
                {analyze.inventoryAnalysisList.length !== 0
                    ? analyze.inventoryAnalysisList.map(el => dynamicTd(el))
                    : dynamicEmptyRow()
                }
                </tbody>
            </table>
        </div>
        {/*
        <PaginationMain totalCount={analyze.totalCount ?? 0}/>
        * */}
    </div>
}